// Whitelist of file types the extraction pipeline can actually process
// (document-extraction: OCR for PDF/raster images, Tika for DOCX/XLSX).
// Fail-closed on purpose: the service rejects archives/executables with 422,
// which genesis currently turns into a whole-batch failure, and SVG dies in
// the OCR provider with 502. Anything not listed here is blocked in the UI
// before it reaches the backend.
const ANALYZABLE_EXTENSIONS = new Set([
  "pdf",
  "docx",
  "xlsx",
  "png",
  "jpg",
  "jpeg",
  "webp",
  "tif",
  "tiff",
]);

const ANALYZABLE_MIME_TYPES = new Set([
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/tiff",
]);

/** `accept` attribute value for file pickers feeding the analysis. */
export const ANALYZABLE_ACCEPT = [...ANALYZABLE_EXTENSIONS].map((e) => `.${e}`).join(",");

export function isAnalyzableDocument(fileName: string, mimeType?: string | null): boolean {
  const dot = fileName.lastIndexOf(".");
  if (dot >= 0 && ANALYZABLE_EXTENSIONS.has(fileName.slice(dot + 1).toLowerCase())) {
    return true;
  }
  return !!mimeType && ANALYZABLE_MIME_TYPES.has(mimeType.toLowerCase());
}
